import container from "../../libs/container/container";

const amdTopicsDescriptionModule = (function () {
    const name = 'topics__description-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    }

    view.startup = function () {
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDescriptionHeaderBigCls, 'animate__bounce', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDescriptionHeaderColumnCls, 'animate__fadeInLeft25P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDescriptionFiltersColumnCls, 'animate__fadeInRight25P', name, {
            dynamicPosHeight: true
        });
    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdTopicsDescriptionModule;